// extracted by mini-css-extract-plugin
export default {"ns_diagram":"ProjectDiagram_ns_diagram__7j-tW","ns_diagram_fullscreen":"ProjectDiagram_ns_diagram_fullscreen__65+kP","ns_rf_controls":"ProjectDiagram_ns_rf_controls__tMrk+"};